import { css } from '@emotion/core'
import { palette } from '~/utils/colors'

export const container = css`
	border-radius: 50px;
	background: ${palette.common.white};
	padding: 4px 8px;
	font-size: 8px;
	color: ${palette.primary.main};
`